























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class ModalInformativo extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: 'Información' }) titulo: string;
  @Prop({ default: 'Cerrar' }) textoBtnNo!: string;
  @Prop({ default: 380 }) width!: number;
  modal_informativo: boolean = false;

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.modal_informativo = value;
  }

  closeModal(val: boolean) {
    this.$emit('modalInformativo', val);
    this.modal_informativo = false;
  }
}
